var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "full__video" }, [
      _c("div", { staticClass: "intro__content intro__content--mobile" }, [
        _c("h1", { staticClass: "hostingEmbed__title" }, [
          _vm._v("Embed and Share Cinemagraphs")
        ]),
        _c("h2", [_vm._v("Share your visual stories on a global stage")]),
        _c(
          "div",
          { staticClass: "btn__group btn__group--splash" },
          [
            _c("get-plan", { attrs: { classes: "btn btn--white btn__splash" } })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "fluid__video" }, [
        _c("div", { staticClass: "intro__content intro__content--desktop" }, [
          _c("h1", { staticClass: "hostingEmbed__title" }, [
            _vm._v("Embed and Share Cinemagraphs")
          ]),
          _c("h2", [_vm._v("Share your visual stories on a global stage")]),
          _c(
            "div",
            { staticClass: "btn__group" },
            [_c("get-plan", { attrs: { classes: "btn btn--white" } })],
            1
          )
        ]),
        _c("iframe", {
          staticClass: "lazy",
          attrs: {
            "data-src":
              "https://media.flixel.com/cinemagraph/jy9hh46vole2fu9znowb?hd=true",
            allow: "autoplay"
          }
        }),
        _vm._m(0)
      ])
    ]),
    _vm._m(1),
    _vm._m(2),
    _vm._m(3),
    _c("section", { staticClass: "flixelPlan__section" }, [
      _c("div", { staticClass: "flixelPlan__container" }, [
        _c("h1", [_vm._v("Choose a plan that’s right for you")]),
        _c("p", [
          _vm._v(
            "Whether you’re a photographer, marketer, or designer, creating cinemagraphs is fun, fast, and easy with Cinemagraph Pro. Select a plan and start using the best cinemagraph creation tools and web-sharing platform."
          )
        ]),
        _c(
          "div",
          { staticClass: "btn__group" },
          [_c("get-plan", { attrs: { classes: "btn btn--white" } })],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credit" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://flixel.com/lensofadventure/"
          }
        },
        [_vm._v("Lensofadventure")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "hosting__section" }, [
      _c("div", { staticClass: "hosting__section--container" }, [
        _c("div", { staticClass: "hosting__section--content" }, [
          _c("div", { staticClass: "hosting__item--title" }, [
            _c("h2", [_vm._v("Cinemagraphs everywhere")])
          ]),
          _c("div", { staticClass: "hosting__item--desc" }, [
            _c("p", [
              _vm._v(
                "Use the unique Flixel embed code to easily display your cinemagraphs that will auto-play and auto-loop on websites and blogs."
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "hosting__item--cinemagraph" }, [
          _c("div", { staticClass: "fluid__video" }, [
            _c("iframe", {
              attrs: {
                "data-src":
                  "https://media.flixel.com/cinemagraph/gaeo6szkj6bg0pvwc1xr?hd=true",
                allow: "autoplay"
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "hosting__section" }, [
      _c(
        "div",
        {
          staticClass: "hosting__section--container hosting__section--reverse"
        },
        [
          _c("div", { staticClass: "hosting__section--content" }, [
            _c("div", { staticClass: "hosting__item--title" }, [
              _c("h2", [_vm._v("Share with the world")])
            ]),
            _c("div", { staticClass: "hosting__item--desc" }, [
              _c("p", [
                _vm._v(
                  "Your work becomes an infinite experience that will inspire audiences around the world on Flixel.com. Create a custom Flixel gallery filled with your beautiful visual stories in stunning HD and use it as a portfolio to grow your business."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "hosting__item--cinemagraph" }, [
            _c("div", { staticClass: "fluid__video" }, [
              _c("iframe", {
                attrs: {
                  "data-src":
                    "https://media.flixel.com/cinemagraph/7kcb88fjch55b1922rnz?hd=true",
                  allow: "autoplay"
                }
              })
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "hosting__section" }, [
      _c(
        "div",
        {
          staticClass: "hosting__section--container hosting__section--benefits"
        },
        [
          _c("div", { staticClass: "hosting__item" }, [
            _c("div", { staticClass: "hosting__item--img" }, [
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  "data-srcset":
                    "https://cdn.flixel.com/static/static-web/icons/hosting-storage@2x.png 2x, https://cdn.flixel.com/static/static-web/icons/hosting-storage.png"
                }
              })
            ]),
            _c("div", { staticClass: "hosting__item--title" }, [
              _c("h2", [
                _vm._v("Unlimited Cinemagraph Uploads for your Flixel Gallery")
              ])
            ]),
            _c("div", { staticClass: "hosting__item--desc" }, [
              _c("p", [
                _vm._v(
                  "Create and upload your work without worrying about the space."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "hosting__item" }, [
            _c("div", { staticClass: "hosting__item--img" }, [
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  "data-srcset":
                    "https://cdn.flixel.com/static/static-web/icons/hosting-views@2x.png 2x, https://cdn.flixel.com/static/static-web/icons/hosting-views.png"
                }
              })
            ]),
            _c("div", { staticClass: "hosting__item--title" }, [
              _c("h2", [_vm._v("100,000 web embed views per month")])
            ]),
            _c("div", { staticClass: "hosting__item--desc" }, [
              _c("p", [
                _vm._v(
                  "Capture and hold attention on blogs and websites with over one million free embed views annually."
                )
              ])
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-511eefae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511eefae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/hosting.vue
// module id = null
// module chunks = 